import { NativeQ } from '../data/native-q';
import { RpcBase, RpcBaseData, rpcCommandVersion, RpcInboundCommands, RpcOutboundCommands, RpcOutboundHandlers, RpcType } from './rpc-base';
import { RpcChannel } from './rpc-channel';

/**
 * RpcToShell class.
 * - Module (tool) uses the instance to communicate to Shell.
 */
export class RpcInbound extends RpcBase {
    /**
     * Initiates a new instance of the RpcToShell class.
     *
     * @param rpcChannel the rpc channel.
     * @param name the public name of the module.
     * @param origin the origin url.
     */
    constructor(rpcChannel: RpcChannel, name: string, origin: string) {
        super(rpcChannel, name, origin, RpcType.Inbound);
        const commands = Object.keys(RpcOutboundCommands);
        commands.forEach((command) => {
            this.register(command, this.emptyHandler);
        });
    }

    /**
     * Registers all handlers at once.
     *
     * @param handlers the Shell handlers.
     */
    public registerAll(handlers: RpcOutboundHandlers): void {
        const handlerNames = Object.keys(handlers);
        handlerNames.forEach((handlerName) => {
            const command = RpcBase.handlerToCommandName(handlerName);
            this.register(command, handlers[handlerName]);
        });
    }

    /**
     * The failed command.
     *
     * @param data the RpcBaseData object.
     * @return Promise<void> the promise object.
     */
    public failed(data: RpcBaseData): Promise<void> {
        return this.rpcChannel.post<RpcBaseData, void>(
            this, { command: RpcInboundCommands[RpcInboundCommands.Failed], version: rpcCommandVersion, data: data });
    }

    /**
     * The empty handler to response always resolved.
     *
     * @return Promise<string> the promise.
     */
    private emptyHandler(_: RpcBaseData): Promise<any> {
        return NativeQ.resolved<any>('emptyHandler');
    }
}
